$( document ).ready(function() {
    // var $bannerHeight = $(window).height() * 0.8 - $('#shopify-section-announcement-bar').height();
    // $('.c-main-banner__banner-item').css('height', $bannerHeight);

    // $(window).resize(function(){
    //     var $bannerHeight = $(window).height() - $('#shopify-section-announcement-bar').height();
    //     $('.c-main-banner__banner-item').css('height', $bannerHeight);
    // })
    
    $('.c-main-banner__video--button').click(function(){
        var $video = $(this).parents('.c-main-banner__video--video').find('video');
        $button = $(this);
        $video[0].play();
        $button.hide();
        $('.c-main-banner__content').hide();
        $video.on('ended',function(){
            $button.show();
            $('.c-main-banner__content').show();
        });
    })

    $('.c-main-banner__video--audio-mute').click(function(){
        var $video = $(this).parents('.c-main-banner__video--video').find('video');
        $button = $(this);
        if($video[0].muted == true){
            $video[0].muted = false;
            $button.addClass('c-main-banner__video--audio-non-mute');
        }else{
            $video[0].muted = true;
            $button.removeClass('c-main-banner__video--audio-non-mute');
        }
    })
    
    if($('.c-main-banner__video--video video').length){
        $('.c-main-banner__video--video video').click(function(){
            var $video = $(this);
            if(!$(this).paused){
                var $button = $video.parents('.c-main-banner__video--video').find('.c-main-banner__video--button');
                $video[0].pause();
                $button.show();
                $('.c-main-banner__content').show();
            }
        })
    }
});
